import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../../Hooks/useFormName';
import ErrorMessage from '../../../../../Components/Form/components/ErrorMessage';
import TopFieldContent from '../../../../../Components/Form/components/TopFieldContent';
import { InputProps } from '../../../../../Components/Form/components/Input';
import RichText from '../RichText/RichText';
import CharactersCount from '../../../../../Components/Form/components/CharactersCount/CharactersCount';

interface Props extends InputProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	charactersLimit?: number;
	showCharCounter?: boolean;
}

const RichTextField: React.FC<Props> = ({
	name,
	label,
	isRequired,
	className,
	charactersLimit,
	showCharCounter = false,
}: Props) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: '',
	});

	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<RichText value={field.value} onChange={field.onChange} />
			{error?.message && <ErrorMessage tx={error.message} />}
			{charactersLimit && showCharCounter && (
				<CharactersCount limit={charactersLimit} value={field.value.plain} />
			)}
		</div>
	);
};

export default RichTextField;
